window.customSwatchHexMap = {
  "FUCHSIA / SILVER": ["#eb6892", "#ede5e300"],
  "BLACK/YELLOW": ["#000000","#fff997"],
  "SANDSTONE": "#d2b48c",
  "IVORY": "#fffff0",
  "MOCHA": "#837060",
  "PURPLE MULTI": ["#9e4d91", "#800080", "#d8bfd8", "#ffffff"],
  "COGNAC": "#9A463D",
  "ARMY GREEN": "#14461a",
  "BLUSH": ["#d4bebe"],
  "SILVER": "#C0C0C0",
  "NUDE": ["#B87348", "#D4BB9F"],
  "CAMO": "#3C3F2F",
  "PINK": "#FFC0CB",
  "CAMOUFLAGE": "#78866B",
  "PURPLE": "#800080",
  "TURQUOISE": "#5ab4b7",
  "PINK CAMOUFLAGE": "#90808f",
  "BROWN": "#a2634a",
  "GREY CAMOUFLAGE": "#524d48",
  "SLATE BLUE": "#7b93b9",
  "OFF WHITE": "#FAF9F6",
  "LILAC /BLACK": ["#c99ccc","#000000"],
  "DENIM / SILVER": "#6e83a5",
  "DENIM": ["#6F8FAF", "#434b62"],
  "BEIGE/BLACK": "#af7551",
  "CAMO / RED PLAID": "#a08384",
  "ARMY": "#8f7651",
  "WHITE/WHT": "#faf5f2",
  "MUSTARD": "#d79237",
  "GREY PLAID": "#9e918a",
  "PLAID/DENIM": "#657ca3",
  "BLUE DENIM": "#374658",
  "DENIM": "#374658",
  "GREY PLAID DENIM": "#96a6be",
  "LEOPARD PRINT": ["#d2b48c", "#000000", "#a0522d"],
  "YELLOW MULTI": ["#ffff00", "#000"],
  "BLACK/MULTI": "#000000",
  "BLACK/MULTI PRINT": ["#000000", "#ff69b4", "#00ffff", "#ffff00"],
  "BLUE/MULTI": ["#0000ff", "#add8e6", "#ffffff"],
  "WHITE": "#ffffff",
  "GREY/OLIVE CAMO": ["#808080", "#556b2f", "#a9a9a9"],
  "GREY/YELLOW CAMO": ["#808080", "#ffff00", "#a9a9a9"],
  "NEWSPRINT": ["#f5f5f5", "#000000"],
  "BLK/WHT DOTS": ["#000000", "#ffffff"],
  "MULTI - PINK": ["#ffc0cb", "#ff69b4", "#ffb6c1"],
  "NAVY": "#000080",
  "NAVY/MULTI": ["#000080", "#ff69b4", "#00ffff", "#ffff00"],
  "LIGHT SILVER": "#d3d3d3",
  "MINT": "#98ff98",
  "MUSTARD PLAID": ["#ffdb58", "#8b4513", "#ffffff"],
  "WHITE PLAID": ["#ffffff", "#d3d3d3", "#e0e0e0"],
  "NAVY GREY": "#4c5866",
  "MULTI GREY": ["#d3d3d3", "#a9a9a9", "#808080", "#696969"],
  "GREY MULTI": ["#d3d3d3", "#a9a9a9", "#808080", "#696969"],
  "BLACK DENIM": ["#1c1c1c","#9ac0da"],
  "GREY/GOLD": ["#808080", "#ffd700"],
  "GREY": "#808080",
  "RED MULTI": ["#ff0000", "#000"],
  "DENIM PRINT": ["#6f8faf", "#5a7d9a", "#3c597b"],
  "BLACK/BLUE": ["#000000", "#0000ff"],
  "POWDER BLUE": "#b0e0e6",
  "PINK BLUSH": "#f2c6c2",
  "PEACH": "#ffdab9",
  "BLACK/GREY": ["#000000", "#808080"],
  "YELLOW FLORAL": ["#ffff00", "#ffffff", "#228b22"],
  "BLACK / HOUNDSTOOTH": ["#000000", "#ffffff"],
  "GREEN / WHITE": ["#008000", "#ffffff"],
  "ORANGE/WHITE": ["#ffa500", "#ffffff"],
  "GOLD": "#ffd700",
  "GOLD/BLACK": ["#ffd700","#000000"],
  "FUCHSIA": "#b6498a",
  "JADE": "#00a86b",
  "WHITE / DENIM": ["#ffffff", "#6f8faf"],
  "BLACK LEOPARD": ["#000000", "#654321", "#d2b48c"],
  "IVORY": "#fffff0",
  "WHITE & BLACK POLKA DOT": ["#ffffff", "#000000"],
  "HUNTER GREEN": "#355e3b",
  "DUSTY ROSE": "#dcae96",
  "ORANGE MULTI": ["#ffa500", "#ff4500", "#ffff00", "#ffffff"],
  "BURGUNDY": "#800020",
  "KHAKI": "#f0e68c",
  "BLACK/LIME": ["#000000", "#a7c547"],
  "LAVENDER": "#e6e6fa",
  "COMIC PRINT": ["#ff0000", "#ffff00", "#0000ff", "#000000", "#ffffff"],
  "BLACK PRINT": "#000000",
  "KHAKI / BLACK": ["#f0e68c", "#000000"],
  "LIME": "#00ff00",
  "CAMOUFLAGE/BLACK": ["#78866b", "#3c3f2f", "#000000"],
  "BLACK/RED": ["#000000","#a40e15"],
  "BLACK/ORANGE": ["#000000","#FFA500"],
  "OLIVE/ORANGE": "#5b4e3b",
  "DENIM / BLACK": ["#babcb4","#000000"],
  "BLACK/WHITE": ["#000000","#ffffff"],
  "BLK/WHT DOTS": ["#000000","#ffffff"],
  "WHT/BLACK": ["#ffffff","#000000"],
  "ORANGE/BLACK": ["#e7a25d","#000000"],
  "LIME/BLACK": ["#d4e678","#000000"],
  "YELLOW/BLACK": ["#ebef5a","#000000"],
  "BLACK/GOLD": ["#000000","#cdb570"],
  "BLUE /BLACK": ["#17a5ed","#000000"],
  "WHITE/RED": ["#ffffff","#ce2645"],
  "GREEN/MULTI": "#729735",
  "MULTI": ["#b67c70","#7b4f47","#ad796e", "#c7898a"],
  "RED/PURPLE": ["#fa545b","#73234e"],
  "NAVY/FUCHSIA": ["#2d2c42","#f65699"],
  "YELLOW/NAVY": ["#f6dd6c","#34323e"],
  "BLACK/PINK": ["#000000","#f2dbdd"],
  "COFFEE/BLACK": ["#bc947b","#000000"],
  "HOUNDSTOOTH": ["#000000", "#ffffff"],
  "NAVY/WHITE": ["#3b425b", "#ffffff"],
  "BLACK/SILVER": ["#000000", "#9e9b96"],
  "BLACK/MUSTARD": ["#000000", "#FFDB58"],
  "PINK MULTI": ["#e2b3b7", "#f15981"],
  "BLACK MULTI": ["#d6ccc6", "#000000"],
  "MULTI PRINT": ["#d03752","#e46756", "#e56788"],
  "BLACK / DENIM": ["#1c1c1c","#9ac0da"],
  "BLACK": "#000000",
  "BLACK/BLACK": "#000000",
  "PURPLE/BLACK": ["#800080" ,"#000000"],
  "RED/BLACK": ["#FF0000" ,"#000000", "#ffffff"],
  "RED/NAVY/WHT": ["#FF0000" ,"#000080"],
  "LIME/WHITE": ["#00FF00", "#ffffff" ],
  "WHITE SILVER": ["#ffffff", "#C0C0C0"],
  "FUCHSIA/WHITE": ["#FF00FF", "#ffffff" ],
  "YELLOW/WHITE": ["#FFFF00", "#ffffff" ],
  "DENIM/KHAKI": ["#1560BD", "#F0E68C" ],
  "CORAL/WHITE": ["#FF7F50", "#ffffff" ],
  "YELLOW/GOLD MULTI": ["#FFFF00", "#FFD700" ],
  "LEOPARD": ["#f48700", "#e5cf8c", "#ffffff", "#a37319", "#000000"],
  "WHITE": "#ffffff",
  "BLUE": "#859dc0",
  "GREEN": "#14461a",
  "WHITE/MULTI": "#ffffff",
  "OLIVE": "#554c3b",
  "OLIVE MULTI": "#808000",
  "DOLLAR": "#85bb65",
  "RED": "#ff0000",
  "YELLOW": "#ffff00",
  "BLACK": "#000000",
  "Black": "#000000",
  "EMERALD": "#50C878",
  "LEMON": "#e6c770",
  "LEMON GRASS": "#c7bf57",
  "DENIM BLUE": "#7aa2c4",
  "CHAIN PRINT": "#b19e8b",
  "ROYAL MULTI":" #064caf",
};
